export const getSlickProperties = (value)=>{
	let properties = makeResponsive({
		component: "StdObjectControl",
		properties: {
			slidesToShow: {
				component:'__experimentalNumberControl', 
				label:__('item per slide', 'webfactory-slick'), 
				min: 1, 
				max: 6
			},
			slidesToScroll: {
				component: '__experimentalNumberControl', 
				label:__('item scroll step', 'webfactory-slick'), 
				min: 1, 
				max:6
			},
			infinite: {
				component:'OnOffControl', 
				label:__('Infinite', 'webfactory-slick')
			},
			fade: {
				component:'OnOffControl', 
				label:__('Fade', 'webfactory-slick')
			},
			autoplay: {
				component:'OnOffControl', 
				label:__('Autoplay', 'webfactory-slick')
			},
			autoplaySpeed: {
				min: 0,
				max: 20000,
				stop: 100,
				component:'__experimentalNumberControl', 
				label:__('Autoplay', 'webfactory-slick')
			},
			arrows: {
				component:'OnOffControl', 
				label:__('Arrows', 'webfactory-slick')
			},
			dots: {
				component:'OnOffControl', 
				label:__('Dots', 'webfactory-slick')
			}
		}
	}, value);
}
export const  makeResponsive = (field, value)=>{
	let properties = {}
	screens.map(screen=>{
		if (!value?.autoplay){
			delete field.properties.autoplaySpeed
		}
		properties[screen.value] = {...field, className:"field-screen-size field-screen-size-"+screen.value}

	})
	return properties;
}

export const screens = [
	{breakpoint: 600,  value: 'xs', icon: 'smartphone', label: 'Mobile'},
	{breakpoint: 1024, value: 'sm', icon: 'tablet', label: 'Tabet'},
	{breakpoint: 1024, value: 'md', icon: 'desktop', label: 'Desktop'},
	]

export const sanitize = (value)=>{
	let x = {
		type: 'slides'
	}
	Object.keys(SLICK_DEFAULTS).map(size=>{
		x[size] = {...SLICK_DEFAULTS[size], ...value[size]}
		x[size].slidesToShow = parseInt(x[size].slidesToShow)
		x[size].slidesToScroll = parseInt(x[size].slidesToScroll)
	});
	return x;

}

export const getBreakpoint = (size)=>{
	return screens.find(x=>x.value == size)?.breakpoint;
}

export const toCssVar = (value, defaultValue)=>{
	if (value === null || value=== undefined){
		return defaultValue;
	}
	if (/^var/.test(value)){
		let v = '--'+value.replace('var:', 'wp|').split('|').join('--');
		return 'var('+v+')';
	}
	return defaultValue;
}